import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Homepage from '../Homepage';
import About from '../About';
import Contact from '../Contact';
import Insurances from '../Insurances';
import Resources from '../Resources';
import Fees from '../Fees';

export const Routes = ({innerWidth}) => (
  <Switch>
    <Route exact path="/" component={Homepage} />
    <Route exact path="/about" component={About} />
    <Route
      exact
      path="/contact"
      render={() => <Contact innerWidth={innerWidth} />}
    />
    <Route exact path="/insurances" component={Insurances} />
    <Route exact path="/fees" component={Fees} />
    <Route
      exact
      path="/resources"
      render={() => <Resources innerWidth={innerWidth} />}
    />
  </Switch>
);

export default Routes;
